/* eslint-disable */
import React, { useState } from 'react';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Button from 'src/onboarding/components/ui/button/Button';
import { MultiImageSelect } from 'src/onboarding/components/ui/multi-image-select/MultiImageSelect';
import { ImageOption } from 'src/onboarding/components/ui/multi-image-select/ImageOption';
import { images } from 'src/onboarding/constants/images';

function Page() {
  const chooseSnack = useStore((state) => state.chooseSnack);
  const setChooseSnack = useStore((state) => state.setChooseSnack);
  const [next, setNext] = useState(chooseSnack.length > 0);
  const { onNext, onPrev, currentIndex } = useNav();

  const handleChange = (value) => {
    setChooseSnack(value);
    setNext(value.length > 0);
  };

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.chooseSnack.title')}</Title>
        <Text className='description' size='m' medium style={{ padding: '0 35px' }}>
          {t('onboarding.chooseSnack.subTitle')}
        </Text>
      </div>

      <div className={'cards'} style={{ marginBottom: 70 }}>
        <MultiImageSelect
        onChange={handleChange}
        defaultValue={chooseSnack}
      >
        <ImageOption
          value="Granola with milk"
          image={images.snack24}
          label={t('onboarding.chooseSnack.options.granola')}
        />
        
        <ImageOption 
          value="Whole-grain crispbreads with soft cheese and salmon"
          image={images.snack25}
          label={t('onboarding.chooseSnack.options.crispbreads')}
        />
        
        <ImageOption 
          value="Pink smoothie"
          image={images.snack27}
          label={t('onboarding.chooseSnack.options.smoothie')}
        />
        
        <ImageOption 
          value="Avocado and chickpea sandwich"
          image={images.snack37}
          label={t('onboarding.chooseSnack.options.sandwich')}
        />
        <ImageOption 
          value="Tuna and bean salad"
          image={images.snack36}
          label={t('onboarding.chooseSnack.options.salad')}
        />
        <ImageOption 
          value="Raspberry-chocolate pudding"
          image={images.snack35}
          label={t('onboarding.chooseSnack.options.pudding')}
        />
      </MultiImageSelect>
      <div className={'overlay'}></div>
      </div>

      <div className={'next-wrapper'}>
        <Button
          className={next ? '' : 'disabled'}
          title={t('onboarding.eatingHabits.continue')}
          onClick={() => {
            if (!next) return;
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'choose-snack',
              answer: chooseSnack.join(', '),
            });
            onNext();
          }}
        />
      </div>
    </div>
  );
}
export default Page;
